// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"FAQPop_ConfirmationPop__ZN4q1","modalBody":"FAQPop_modalBody__j1Z0F"};